import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03a6341c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","flex-direction":"column","height":"100%"} }
const _hoisted_2 = { class: "index-box" }
const _hoisted_3 = { class: "form-btn-group" }

import { inject, ref } from 'vue';
import { WindowTool } from '@/components/common/window/WindowInterface';
import SelectModelTable from '@/components/business/crud/common/SelectModelTable.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectModelDialog',
  props: {
    moduleName: {},
    controllerName: {},
    labelName: {},
    hiddenFields: {},
    condition: {}
  },
  setup(__props: any) {

const props = __props;

const options = ref<any[]>([]);

const windowTool = inject<WindowTool | false>(WindowTool, false);

async function onSubmit() {
  if (windowTool) {
    windowTool.close(options.value);
  }
}

function onReset() {
  options.value = [];
}

return (_ctx: any,_cache: any) => {
  const _component_sc_btn = _resolveComponent("sc-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SelectModelTable, {
        modelValue: options.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((options).value = $event)),
        "module-name": _ctx.moduleName,
        "controller-name": _ctx.controllerName,
        "label-name": _ctx.labelName,
        condition: _ctx.condition,
        "hidden-fields": _ctx.hiddenFields
      }, null, 8, ["modelValue", "module-name", "controller-name", "label-name", "condition", "hidden-fields"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_sc_btn, {
        handler: onSubmit,
        text: "确定",
        type: "primary"
      }),
      _createVNode(_component_sc_btn, {
        handler: onReset,
        style: {"margin-left":"10px"},
        text: "重置"
      })
    ])
  ]))
}
}

})